import { render, staticRenderFns } from "./SkuSingle.vue?vue&type=template&id=321acf6d&scoped=true"
import script from "./SkuSingle.vue?vue&type=script&lang=js"
export * from "./SkuSingle.vue?vue&type=script&lang=js"
import style0 from "./SkuSingle.vue?vue&type=style&index=0&id=321acf6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321acf6d",
  null
  
)

export default component.exports